import axios from "axios";
import { useQuery } from "@tanstack/react-query";

const API = process.env.REACT_APP_BASE_URL + "hec/";
export const TOAST = { autoClose: 15000 };

// GET a list from the hec API; failures are logged and read as an empty list so the form still renders
const fetchList = async (path, params) => {
  try {
    const { data } = await axios.get(API + path, { params });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error(`Failed to load ${path}`, error);
    return [];
  }
};

export const useList = (queryKey, path, { params, enabled = true } = {}) =>
  useQuery({
    queryKey,
    queryFn: () => fetchList(path, params),
    enabled,
    staleTime: 30 * 60 * 1000,
  }).data ?? [];

// Sectors, cells or villages under the chosen parent location
export const useChildLocations = (parentCode) =>
  useList(["locations", parentCode], "location/getLocaitonsByParent", { params: { parentCode }, enabled: Boolean(parentCode) });

export const locationOptions = (locations) => locations.map((l) => ({ value: l.locationCode, label: l.locationName }));
